
var sprite = require("D:/a/1/s/Web/CMS/App_Themes/Safestore/node_modules/svg-sprite-loader/lib/web/global-sprite");
var image = "<symbol viewBox=\"0 0 20 20\" id=\"icon-error\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"> <path d=\"M10,0C4.477,0,0,4.477,0,10s4.477,10,10,10c5.523,0,10-4.477,10-10S15.523,0,10,0 M8.717,3.712\r\n\tc0-0.236,0.191-0.428,0.427-0.428h1.71c0.236,0,0.427,0.192,0.427,0.428v9.059c0,0.236-0.191,0.427-0.427,0.427h-1.71\r\n\tc-0.236,0-0.427-0.191-0.427-0.427V3.712z M10,17.31c-0.827,0-1.497-0.669-1.497-1.497c0-0.826,0.67-1.497,1.497-1.497\r\n\ts1.497,0.67,1.497,1.497C11.497,16.641,10.827,17.31,10,17.31\"/> </symbol>";
module.exports = sprite.add(image, "icon-error");


/*****************
 ** WEBPACK FOOTER
 ** ./svg/src/error.svg
 ** module id = 173
 ** module chunks = 24
 **/